module.exports = __webpack_public_path__ + "img/gruppo_mail_todolist.50ef2ae6.png";